import { IAuthRepsAction } from 'redux/reducers/auth-reps'
import { isValidDateObject } from 'utils/dateAuthRep'

export interface IAuthRepsActionWithPastRepFlag extends IAuthRepsAction {
  isPastRep: boolean
}

// UPDATE THIS CODE, check for undefined
export const addIsPastRepField = (reps: any) => {
  const repsWithPastFlag = reps.map((rep: IAuthRepsActionWithPastRepFlag) => {
    const date = new Date()
    const msInADay = 24 * 60 * 60 * 1000
    const timeNowMinus1Day = date.getTime() - msInADay
    if (!isValidDateObject(rep.authEndDate) || rep.disclosurePeriod === 'disclose_indefinitely' ||
    // if (rep.disclosurePeriod === 'disclose_indefinitely' ||
    (rep.authEndDate &&
      (Date.parse(`${rep.authEndDate.month}/${rep.authEndDate.day}/${rep.authEndDate.year}`) > timeNowMinus1Day))) {
      rep.isPastRep = false
    } else {
      rep.isPastRep = true
    }
    return (rep)
  })
  return repsWithPastFlag
}
